import moment from 'moment';

import { Link, useLocation } from 'react-router-dom';

import user from '../../assets/user.png';

/*
 * Un élément de la liste des conversations.
 * Styles : mc-inbox.css (importé par la page de messagerie).
 * `onSelect` permet de fermer l'offcanvas mobile au clic.
 */
function MemberItem({ data, onSelect }) {
  const location = useLocation();

  const reservationId = data?.reservationId;

  const isActive = location.pathname.includes(`/inbox/messages/thread/${reservationId}`);

  const fullName = `${data?.Invite?.firstName || ''} ${data?.Invite?.lastName || ''}`.trim();
  const vehicleLabel = [data?.Vehicle?.VehicleModel?.marque, data?.Vehicle?.VehicleModel?.modele]
    .filter(Boolean)
    .join(' ');

  return (
    <li className="mc-ib-thread">
      <Link
        to={`/inbox/messages/thread/${reservationId}`}
        className={`mc-ib-thread-link${isActive ? ' is-active' : ''}`}
        aria-current={isActive ? 'page' : undefined}
        onClick={onSelect}
      >
        <img
          src={data?.Invite?.profile_url || user}
          alt=""
          className="mc-ib-avatar"
          width="46"
          height="46"
          loading="lazy"
        />

        <div className="mc-ib-thread-body">
          <p className="mc-ib-thread-name">{fullName || 'Conversation'}</p>
          <p className="mc-ib-thread-meta">{vehicleLabel || 'Véhicule'}</p>
          {data?.Vehicle?.description && (
            <p className="mc-ib-thread-desc">{data.Vehicle.description}</p>
          )}
        </div>

        {data?.createdAt && (
          <small className="mc-ib-thread-time">{moment(data.createdAt).calendar()}</small>
        )}
      </Link>
    </li>
  );
}

export default MemberItem;
